import React from 'react';

const CampaignProgress = ({ status }) => {
  const total = status?.total || 0;
  const done = status?.done || 0;
  const pending = status?.pending || 0;
  const excluded = status?.excluded || 0;
  const percent = total ? Math.round((done / total) * 100) : 0;
  const isComplete = total > 0 && pending === 0;

  return (
    <div className="mt-5">
      <div className="flex items-baseline justify-between gap-3 mb-2">
        <span className="text-sm text-gray-600">
          Обновились <span className="font-medium text-gray-800">{done}</span> из {total}
        </span>
        <span className="text-sm text-gray-500">{percent}%</span>
      </div>
      <div className="h-2 w-full rounded-full bg-gray-100 overflow-hidden" role="progressbar" aria-valuenow={done} aria-valuemin={0} aria-valuemax={total}>
        <div className={`h-full rounded-full transition-all ${isComplete ? 'bg-green-500' : 'bg-orange-500'}`} style={{ width: `${percent}%` }} />
      </div>
      <div className="flex flex-wrap gap-x-6 gap-y-1 mt-2 text-sm text-gray-600">
        <span>
          Ожидают: <span className="font-medium text-gray-800">{pending}</span>
        </span>
        <span>
          Выведены: <span className="font-medium text-gray-800">{excluded}</span>
        </span>
      </div>
    </div>
  );
};

export default CampaignProgress;
